import {
  FunctionList,
  type PromoCodeCreatePostBody,
  type PromoCodeDeletePostBody,
  type PromoCodeList,
  type PromoCodeListRequest,
} from "@repo/common";

import { typedHttpsCallable } from "../../lib/typed-https-callable";

export const listPromoCodes = async (params: Partial<PromoCodeListRequest> = {}): Promise<PromoCodeList> => {
  return typedHttpsCallable<PromoCodeList>({
    functionName: FunctionList.ListPromoCodes,
    data: {
      limit: params.limit ?? 50,
      sort: params.sort ?? "createdOnIsoDate",
      sortDirection: params.sortDirection ?? "desc",
      ...(params.cursorDocId && { cursorDocId: params.cursorDocId }),
    },
  });
};

export const deletePromoCode = async (formData: PromoCodeDeletePostBody): Promise<void> => {
  await typedHttpsCallable<{ message: string }>({
    functionName: FunctionList.DeletePromoCode,
    data: formData,
  });
};

export const createPromoCodes = async (formData: PromoCodeCreatePostBody): Promise<PromoCodeList> => {
  return typedHttpsCallable<PromoCodeList>({
    functionName: FunctionList.CreatePromoCodes,
    data: formData,
  });
};
